module.exports = __webpack_public_path__ + "static/flags/VM-d8a470ee5dd0e87d20e48f6ecbdf7e23.gif";